import loaderImg from "../images/logos/loader.svg";

export default function Loader() {
  return (
    <div class="c-loader">
      <img src={loaderImg} alt="∆ icon" />
    </div>
  );
}
